(() => {
  function init() {
    // The gift-bundle template uses a single main image instead of media panels.
    document.querySelectorAll('.ku-reference-products .retro-gallery').forEach(gallery => {
      if (gallery.hasAttribute('data-gallery')) return;
      const main = gallery.querySelector('.retro-main-image');
      const buttons = [...gallery.querySelectorAll('[data-retro-image]')];
      if (!main || !buttons.length) return;
      gallery.setAttribute('data-gallery', '');
      buttons.forEach((button, i) => {
        button.setAttribute('data-show-media', String(i));
        button.setAttribute('aria-pressed', String(i === 0));
        const cutout = button.querySelector('img')?.getAttribute('src');
        if (cutout?.includes('/assets/ku-cutout-')) button.dataset.retroImage = cutout;
        button.addEventListener('click', () => {
          main.src = button.dataset.retroImage;
          main.removeAttribute('srcset');
          buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        });
      });
    });
    document.querySelectorAll('.ku-reference-products [data-gallery]').forEach(gallery => {
      if (gallery.dataset.krNav) return;
      const thumbs = [...gallery.querySelectorAll('[data-show-media]')];
      if (thumbs.length < 2) return;
      const nav = document.createElement('div');
      nav.className = 'kr-gallery-nav';
      const previous = document.createElement('button');
      const next = document.createElement('button');
      const status = document.createElement('span');
      previous.type = next.type = 'button';
      previous.textContent = '‹';
      next.textContent = '›';
      previous.setAttribute('aria-label', 'Previous product image');
      next.setAttribute('aria-label', 'Next product image');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      nav.append(previous, status, next);
      thumbs[0].parentElement.before(nav);
      let index = 0;
      function sync() {
        const selected = thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        if (selected >= 0) index = selected;
        status.textContent = `${index + 1} / ${thumbs.length}`;
        previous.disabled = index === 0;
        next.disabled = index === thumbs.length - 1;
      }
      thumbs.forEach((button, i) => button.addEventListener('click', () => { index = i; sync(); }));
      previous.addEventListener('click', () => thumbs[Math.max(0, index - 1)].click());
      next.addEventListener('click', () => thumbs[Math.min(thumbs.length - 1, index + 1)].click());
      new MutationObserver(sync).observe(thumbs[0].parentElement, {subtree:true,attributes:true,attributeFilter:['aria-pressed']});
      gallery.addEventListener('show-variant-media', sync);
      gallery.addEventListener('keydown', event => {
        if (event.target.matches('input,select,textarea,video')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          (event.key === 'ArrowRight' ? next : previous).click();
        }
      });
      sync();
      gallery.dataset.krNav = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
